/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Enhanced_Holster_HintInputs */

const cs_property_ai_enhanced_holster_hint = /** @type {(inputs: Property_Ai_Enhanced_Holster_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starší návrhy ještě mimo galerii. Nové výsledky vylepšení/stagingu se přidají do galerie automaticky.`)
};

const en_property_ai_enhanced_holster_hint = /** @type {(inputs: Property_Ai_Enhanced_Holster_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Older drafts not yet in the gallery. New enhance/staging results join the gallery automatically.`)
};

/**
* | output |
* | --- |
* | "Older drafts not yet in the gallery. New enhance/staging results join the gallery automatically." |
*
* @param {Property_Ai_Enhanced_Holster_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_enhanced_holster_hint = /** @type {((inputs?: Property_Ai_Enhanced_Holster_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Enhanced_Holster_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_enhanced_holster_hint(inputs)
	return cs_property_ai_enhanced_holster_hint(inputs)
});